import React from "react"
import {ArrowRight, Sparkles} from 'lucide-react'

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-900 to-slate-950 py-20">
      {/* Animated background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-cyan-400" />
            <span className="text-sm text-cyan-300">Master Dynamic Programming Visually</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-transparent">
            Visualize & Generate
            <br />
            <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text">DP Algorithms</span>
          </h1>
          
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Step through famous Dynamic Programming problems frame-by-frame. 
            Generate optimized code in Python, Java, C++, and JavaScript instantly.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600 rounded-lg font-semibold flex items-center justify-center gap-2 transition-all transform hover:scale-105">
              Start Visualizing
              <ArrowRight className="w-5 h-5" />
            </button>
            <button className="px-8 py-4 bg-slate-800 hover:bg-slate-700 rounded-lg font-semibold border border-slate-600 transition-colors">
              View Examples
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 mt-16 max-w-2xl mx-auto">
            <div>
              <div className="text-3xl font-bold text-cyan-400">5</div>
              <div className="text-slate-400 text-sm">Core Problems</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-400">4</div>
              <div className="text-slate-400 text-sm">Languages</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-amber-400">100%</div>
              <div className="text-slate-400 text-sm">Interactive</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
